import React from 'react';
import { MdError } from 'react-icons/md';

interface PayLaterFailurePopupProps {
  isOpen: boolean;
  onClose: () => void;
  onTryAgain: () => void;
  errorMessage?: string;
}

export const PayLaterFailurePopup: React.FC<PayLaterFailurePopupProps> = ({
  isOpen,
  onClose,
  onTryAgain,
  errorMessage,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
      <div className="bg-white/90 rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all ring-1 ring-white/20">
        <div className="p-6 text-center">
          {/* Error Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4 shadow-md">
            <MdError className="h-8 w-8 text-red-600" aria-hidden="true" />
          </div>

          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Order Failed
          </h3>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            {errorMessage || 'We couldn\'t process your order. Please try again or contact support if the problem persists.'}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={onTryAgain}
              className="bg-red-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-red-600 transition-colors focus:outline-none"
            >
              Try Again
            </button>
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 text-gray-800 py-3 px-6 rounded-lg font-semibold hover:bg-gray-300 transition-colors focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
